/* Reading progress and nonintrusive mobile shop button. No analytics, tracking or checkout manipulation. */
(function(){
  function init(root){
    if (!root || root.dataset.eha1Ready === '1') return;
    root.dataset.eha1Ready = '1';
    var bar=root.querySelector('[data-eha1-progress]');
    var cta=root.querySelector('[data-eha1-mobile-cta]');
    var story=root.querySelector('[data-eha1-root] .eha1-article') || root.querySelector('.eha1-article');
    var offer=root.querySelector('.eha1-offer');
    var last=root.querySelector('.eha1-end');
    var ticking=false;
    function update(){
      ticking=false;
      var box=root.getBoundingClientRect();
      var distance=Math.max(1,box.height-window.innerHeight);
      var done=Math.max(0,Math.min(100,(-box.top/distance)*100));
      if(bar) bar.style.width=done.toFixed(2)+'%';
      if(!cta || !story) return;
      var storyRect=story.getBoundingClientRect();
      var offerRect=offer ? offer.getBoundingClientRect() : null;
      var lastRect=last ? last.getBoundingClientRect() : null;
      var show=storyRect.top < window.innerHeight*0.32 && storyRect.bottom > window.innerHeight*0.2;
      if (offerRect && offerRect.top < window.innerHeight*.72 && offerRect.bottom > window.innerHeight*.15) show=false;
      if (lastRect && lastRect.top < window.innerHeight*.92) show=false;
      cta.classList.toggle('is-visible',show);
    }
    function scroll(){if(ticking)return;ticking=true;window.requestAnimationFrame(update)}
    window.addEventListener('scroll',scroll,{passive:true});
    window.addEventListener('resize',scroll,{passive:true});
    update();
  }
  function start(){document.querySelectorAll('[data-eha1-root]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();
